module.exports = __webpack_public_path__ + "img/buildingBlocks.e31d485e.jpg";